import { render, staticRenderFns } from "./BônusMensal.vue?vue&type=template&id=faae0a9a&scoped=true"
import script from "./BônusMensal.vue?vue&type=script&lang=js"
export * from "./BônusMensal.vue?vue&type=script&lang=js"
import style0 from "./BônusMensal.vue?vue&type=style&index=0&id=faae0a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faae0a9a",
  null
  
)

export default component.exports